import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ActivityFeed = ({ activities = [], loading = false, onRefresh }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'user_registration': return 'UserPlus';
      case 'problem_submission': return 'FileText';
      case 'team_formation': return 'Users';
      case 'course_completion': return 'Award';
      case 'deliverable_upload': return 'Upload';
      case 'system_alert': return 'AlertCircle';
      default: return 'Bell';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'user_registration': return 'success';
      case 'problem_submission': return 'primary';
      case 'team_formation': return 'warning';
      case 'course_completion': return 'success';
      case 'deliverable_upload': return 'primary';
      case 'system_alert': return 'error';
      default: return 'primary';
    }
  };

  const formatTimeAgo = (timestamp) => {
    const now = new Date();
    const activityTime = new Date(timestamp);
    const diffInSeconds = Math.floor((now - activityTime) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)} hours ago`;
    if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)} days ago`;
    return activityTime?.toLocaleDateString();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-soft">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
        {onRefresh && (
          <Button 
            variant="ghost" 
            size="sm"
            iconName="RefreshCw"
            iconPosition="left"
            onClick={onRefresh}
            disabled={loading}
          >
            Refresh
          </Button>
        )}
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
        </div>
      ) : activities?.length === 0 ? (
        <div className="text-center py-12">
          <Icon name="Activity" size={48} className="text-muted-foreground mx-auto mb-2" />
          <p className="text-muted-foreground">No recent activity</p>
        </div>
      ) : (
        <div className="space-y-3">
          {activities?.map((activity) => (
            <div 
              key={activity?.id}
              className="flex items-start space-x-3 p-3 rounded-lg border border-border hover:bg-muted transition-micro"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center bg-${getActivityColor(activity?.type)} text-${getActivityColor(activity?.type)}-foreground flex-shrink-0`}>
                <Icon name={getActivityIcon(activity?.type)} size={20} />
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-medium text-foreground">{activity?.title}</p>
                <p className="text-sm text-muted-foreground mt-1">{activity?.description}</p>
                <div className="flex items-center space-x-2 mt-2">
                  <Icon name="Clock" size={12} className="text-muted-foreground" />
                  <span className="text-xs text-muted-foreground">
                    {formatTimeAgo(activity?.timestamp)}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActivityFeed;